import React from 'react';
import { DashboardMobileStatusFilterControl } from './DashboardFleetStatusFilterButton';

export default function DashboardFleetStatusFilterGrid({ maintenanceFilters, healthFilters }) {
  return (
    <div className="dashboard-fleet-mobile-status-filters" aria-label="Fleet Status filters">
      <div className="dashboard-fleet-mobile-status-columns">
        <div className="dashboard-fleet-mobile-status-column">
          <div className="dashboard-fleet-mobile-status-column-heading">Maintenance</div>
          <div className="dashboard-fleet-mobile-status-grid">
            {maintenanceFilters.map((filter) => (
              <DashboardMobileStatusFilterControl
                key={filter.key}
                active={filter.active}
                label={filter.label}
                value={filter.value}
                tone={filter.tone}
                onClick={filter.onClick}
              />
            ))}
          </div>
        </div>
        <div className="dashboard-fleet-mobile-status-column">
          <div className="dashboard-fleet-mobile-status-column-heading">Health</div>
          <div className="dashboard-fleet-mobile-status-grid">
            {healthFilters.map((filter) => (
              <DashboardMobileStatusFilterControl
                key={filter.key}
                active={filter.active}
                label={filter.label}
                value={filter.value}
                tone={filter.tone}
                onClick={filter.onClick}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
